const ProjectStatus = Object.freeze({
    ALL          : 'ALL'         , // كل الحالات
    DRAFT        : 'DRAFT'       , // مسودة
    CLOSED       : 'CLOSED'      , // مغلقة
    ACTIVE       : 'ACTIVE'      , // نشط
    IDLE         : 'IDLE'        , // خامل
    UNDER_REVIEW : 'UNDER_REVIEW',  // قيد النظر
});

export default ProjectStatus;